import React, { useState } from 'react';
import clinicService from '../../../../../services/clinic.service';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

function NewReputation({ clinicid, checkReputationService }) {
    const [showForm, setShowForm] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { register, handleSubmit, formState: { errors }, reset } = useForm();

    const onSubmit = (data) => {
        setIsSubmitting(true);
        const newData = { ...data, clinicId: clinicid };

        clinicService.addReputationClinic(clinicid, newData)
            .then(res => {
                toast.success("Reputation Enhancement Added Successfully", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                checkReputationService();
                reset();
                setShowForm(false);
            })
            .catch(err => {
                toast.error('Error: Please check your URL and try again', {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    return (
        <div className="container mt-4">
            <div className="card shadow-none card-padding card-border">
                <div className="card-body p-4">
                    {showForm ? (
                        <>
                            <div className="d-flex justify-content-between align-items-center small">
                                <div className="card-title mb-0 text-primary">
                                    <i className="fas fa-star me-2"></i>
                                    Setup Reputation Enhancement
                                </div>
                            </div>
                            <hr/>
                            <form onSubmit={handleSubmit(onSubmit)} className="small">
                                <div className="mb-3">
                                    <label htmlFor="shortCode" className="form-label fw-semibold">
                                        Short Code <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control form-control ${errors.shortCode ? 'is-invalid' : ''}`}
                                        id="shortCode"
                                        placeholder="Enter unique short code"
                                        {...register("shortCode", {
                                            required: "Short code is required",
                                            pattern: {
                                                value: /^[a-zA-Z0-9_-]+$/,
                                                message: "Only letters, numbers, hyphens and underscores allowed"
                                            },
                                            minLength: {
                                                value: 3,
                                                message: "Short code must be at least 3 characters"
                                            }
                                        })}
                                    />
                                    {errors.shortCode && (
                                        <div className="invalid-feedback">
                                            <i className="fas fa-exclamation-circle me-1"></i>
                                            {errors.shortCode.message}
                                        </div>
                                    )}
                                    <div className="form-text">
                                        This short code will be used in your reputation URL.
                                    </div>
                                </div>

                                <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                    <button
                                        type="button"
                                        className="btn btn-danger me-md-2 btn-sm"
                                        onClick={() => {
                                            setShowForm(false);
                                            reset();
                                        }}
                                        disabled={isSubmitting}
                                    >
                                        <i className="bi bi-x-circle"></i> Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-success btn-sm"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Setting Up...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-check me-2"></i>
                                                <i className="bi bi-floppy"></i> Save
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>

                            <div className="alert alert-info mt-4 small">
                                <div className="d-flex">
                                    <div className="me-3">
                                        <i className="fas fa-info-circle fa-2x"></i>
                                    </div>
                                    <div>
                                        <div className="fw-bold">Important Note</div>
                                        <p className="mb-0">
                                            The short code is a unique identifier that will be used in your reputation URL.
                                            Choose something meaningful and easy to remember. Once set, it can't be changed easily.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="text-center py-4 small">
                                <div className="mb-4">
                                    <i className="fas fa-star fa-3x text-muted opacity-25"></i>
                                </div>
                                <h5 className="card-title">Reputation Enhancement</h5>
                                <p className="card-text text-muted mb-4 ">
                                    This clinic doesn't have Reputation Enhancements setup yet.
                                    Create a short code to get started with managing your online reputation.
                                </p>
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => setShowForm(true)}
                                >
                                    <i className="fas fa-plus me-2"></i>
                                    <i className="bi bi-plus"></i> Begin Setup
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default NewReputation;